import { api } from "./index";

export const cmsApi = {
  // 获取首页数据
  getHomeData: () => api.get("/cms/home"),

  // 获取Banner列表
  getBanners: (position?: string) =>
    api.get("/cms/banners", { params: { position } }),

  // 获取推荐列表
  getRecommendations: () => api.get("/cms/recommendations"),

  // 获取网站配置
  getSiteConfig: () => api.get("/cms/config"),

  // 更新网站配置(管理员)
  updateSiteConfig: (data: any) => api.put("/cms/config", data),

  // 获取公告列表
  getAnnouncements: () => api.get("/cms/announcements"),

  // 获取首页模块配置
  getHomeSections: () => api.get("/cms/home-sections"),
};
